import Vuex from "vuex";
import dayjs from "dayjs";
import { StoreState } from "./StoreState";

export function save(state: StoreState) {
  console.log("saving: " + JSON.stringify(state));
  localStorage.setItem("easy-user", JSON.stringify(state));
}
const newState = new StoreState();
export const store = new Vuex.Store({
  state: () => newState,

  mutations: {
    firebaseReady(state: StoreState) {
      state.isFirebaseReady = true;
    },
    onLogin(state: StoreState, response: any) {
      console.log("on login" + JSON.stringify(response));
      const user = response.user;
      if (user == undefined) throw new Error("invalid response:user");
      state.user = user;
      if (state.user == undefined) throw new Error("user is null");
      state.user.cards = response.currentDeck.cards;
      state.sessionId = response.sessionId;
      save(state);
    },
    onSync(state: StoreState, response: any) {
      console.log("on sync" + JSON.stringify(response));
      state.user = response.user;
      if (state.user == undefined) throw new Error("user is null");
      state.user.cards = response.currentDeck.cards;
      save(state);
    },
    logout(state: StoreState) {
      state.user = undefined;
      state.sessionId = undefined;
      localStorage.removeItem("easy-user");
    },
    onLoginSuccess(state, info) {
      if (state.user == undefined) throw new Error("user is null");
      state.user.email = info.email;
      save(state);
    },
    addCard(state, card) {
      console.log("card:" + card);

      if (state.user == undefined) throw new Error("user is null");
      state.user.cards.push(card);
      save(state);
    },
    removeCard(state, card) {
      console.log("card:" + card);
      if (state.user == undefined) throw new Error("user is null");
      const filtered = state.user.cards.filter((x) => x.front != card.front);
      state.user.cards = filtered;
      save(state);
    },

    updateCard(state, card) {
      console.log("card:" + card);
      if (state.user == undefined) throw new Error("user is null");
      const updated = state.user.cards.filter((x) => x.front != card.front);
      card.dueDateDisplay = dayjs(card.dueDate).format("DD/MM/YYYY");
      updated.push(card);
      state.user.cards = updated;
      save(state);
    },
  },

  getters: {
    hasActiveSession(state) {
      return state.sessionId != undefined;
    },
  },
});
const loadedUser = localStorage.getItem("easy-user");
if (loadedUser) {
  const loaded = JSON.parse(loadedUser);
  store.state.user = loaded.user;
  store.state.sessionId = loaded.sessionId;
  store.state.frontLanguage = loaded.frontLanguage;
  store.state.backLanguage = loaded.backLanguage;
}
